/*
 * @Description: store
 * @Author: Rfan
 * @Date: 2020-01-14 11:45:20
 * @LastEditTime: 2024-01-27 10:40:49
 */ 
import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters';

Vue.use(Vuex);

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

export default new Vuex.Store({
  state: {
    userId: '',
    version: '',
    user: {
      id: '',
      nick: '',
      token: '',
      avatar: ''
    },
    token: '',
    imgBaseUrl: 'https://bsyimg.pandapaint.net',
    query: {
      channel: 'wap'
    },
    transferUser: {
      userId: '',
      token: '',
      nick: ''
    },
    safeTransfer: false,
  },
  modules,
  getters,
  mutations: {
    setMemberInfo(state, info) {
      state.user.nick = info?.nick
      state.user.id = info?.userId
      state.userId = info?.userId
      state.user.avatar = info?.avatar || 'https://bsyimg.pandapaint.net/avatar/default/default_head_image.png'
      state.user.token = info?.token
      state.token = info?.token
    },
    setVer(state, ver) {
      state.version = ver
    },
    setQuery(state, info) {
      state.query = { ...info }
    },
    setTransferUser(state, info) {
      state.transferUser.userId = info.userId
      state.transferUser.token = info.token
      state.transferUser.nick = info.nick
    },
    setSafeTransfer(state, status) {
      state.safeTransfer = Boolean(status)
    }

  },
  actions: {
  }
})
